import { NUMBER } from "../../../constants/app-constants";

export  const responseOrder = {
    states: {},
    RTO: {},
    brand: {},
    year: {},
    model: {},
    ds_details: {}

};

export const REGISTRATION_STEP_NAMES = {
    BRAND: "brand",
    YEAR: "year",
    MODEL: "model",
    STATES: "states",
    DS_DETAIL: "ds_details",
    VARIANT: "variant",
    RTO: "RTO"
};

export const getDataByKey = (response, key) => {
    let obj = {};

    if (key === REGISTRATION_STEP_NAMES.BRAND) {
        obj = {
            id: response.brand.make_id,
            displayText: response.brand.make_display
        };
    }

    if (key === REGISTRATION_STEP_NAMES.YEAR) {
        obj = {
            id: parseInt(response.year.year),
            displayText: response.year.year,
            year_id: response.year.year_id
        };
    }

    if (key === REGISTRATION_STEP_NAMES.MODEL) {
        obj = {
            id: response.model.model_id,
            displayText: response.model.model_display
        };
    }

    if (key === REGISTRATION_STEP_NAMES.VARIANT) {
        obj = {
            id: response.variant.variant_id,
            displayText: response.variant.variant_display_name,
            variantType: response.variant.fuel_type
        };
    }

    if (key === REGISTRATION_STEP_NAMES.STATES) {
        obj = {
            id: response.states.state_id,
            displayText: response.states.state_code
        };
    }

    if (key === REGISTRATION_STEP_NAMES.RTO) {
        obj = {
            id: response.RTO.rto_detail_id,
            displayText: response.RTO.rto_code
        };
    }

    return obj;

};

export const STEPS_TO_IGNORE = ["states", "RTO"];

export const COMMERCIAL_CAR_TYPES = ["LPV", "LGV"];

export const formatInputValue = ({inputValue = ""}) => {
    return inputValue.replace(/\s/g, "")
        .split("")
        .map((char, index) => (index === NUMBER.ONE || index === NUMBER.THREE) ? `${char} ` : char)
        .join("")
        .trim();
};
